module.exports = __webpack_public_path__ + "static/media/vodafone.e0718602.svg";